<template>
  <div class="full-height">
    <div
      v-if="!measurementReportForm"
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>ORDER_GENERATED</translate>
            </div>
          </q-card-section>
          <q-card-section id="scroll-table-billing-order-action"  class="q-pb-lg card-table">
            <billing-order-jt-data-table
              v-if="nmInterface && datatable"
              v-bind="$props"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :filter="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              multiselect
              selectionForce
              :row-buttons="rowButtons"
              :selection-force="selectionForce"
              :columnEdit="paintCell"
              @selection="selection"
              @action-button="actionButtonBillingOrder"
              @show-message="showMessage"
              @toggle-change="onToggleChange"
              :row-set="rowSet"
              :isPaginated="false"
              :bottom-edit="bottomEdit"
              @click-row="
                (row) => {
                  $emit('click-row', row);
                }
              "
              @action-change="onActionChange"
            >
              <template v-slot:header="{ props }">
                <q-tr>
                  <q-th auto-width>
                    <q-checkbox
                      v-model="props.selected"
                      color="primary"
                    />
                  </q-th>

                  <q-th></q-th>
                  <q-th
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    {{ col.label }}
                  </q-th>
                  <q-th style="width: 1px" />
                </q-tr>
              </template>
              <template v-slot:body="{ props }">
                <q-tr>
                  <q-td v-if="props" auto-width>
                    <q-checkbox
                      v-if="renderRowCheBox(props)"
                      v-model="props.selected"
                      color="primary"
                      :data-testid="props.row.id"
                      @input="() => ($refs.jtDataTable.selectAll = false)"
                    />
                  </q-td>
                  <q-td style="width: 1px">
                    <span class="buttons-row">
                      <span
                        v-for="(button, index) in buttonsLeft"
                        :key="index"
                        :class="button.name"
                      >
                        <q-btn
                          flat
                          small
                          :class="button.name + '-btn protocol-close'"
                          color="primary"
                          :disable="!filterButton(button, props.row, false)"
                          v-if="filterButton(button, props.row, true)"
                          @click="actionButtonBillingOrder(button, props.row)"
                        >
                          <q-icon :name="iconAction(button)" size="22px" />
                          <q-tooltip v-if="button.tooltip">
                            {{ tooltip(button, props.row) }}
                          </q-tooltip>
                          <q-tooltip v-else>{{ button.label }}</q-tooltip>
                        </q-btn>
                      </span>
                    </span>
                  </q-td>
                  <q-td
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                    :class="availableStyle({ col: col, props: props })"
                    @click="onClickRow({ col: col, props: props })"
                  >
                    <q-tooltip v-if="col.tooltip">
                      {{ tooltip(col, props.row) }}
                    </q-tooltip>

                    <img
                      class="image"
                      v-if="col.name === 'imageGrid'"
                      :src="imgsrc(col.value)"
                    />
                    <span
                      v-else-if="
                        (() => {
                          col.htmlProcessed = paintCell({
                            col: col,
                            props: props,
                          });
                          return col.htmlProcessed;
                        })()
                      "
                    >
                      <div v-html="col.htmlProcessed"></div>
                    </span>

                    <span v-else-if="col.edit">
                      <jt-data-table-input
                        :props="props"
                        :col="col"
                        :nmInterface="nmInterface"
                        @search-found="
                          (data) =>
                            $emit('search-found', { [input.model]: data })
                        "
                        @on-select-change="
                          (data) => $emit('on-select-change', data)
                        "
                        @on-select-ajax="
                          (data) => $emit('on-select-ajax', data)
                        "
                        @input="
                          (data) => onInputRow(data, { col: col, props: props })
                        "
                        @toggle-change="
                          (data) => {
                            $refs.jtDataTable.onToggleChange(data, {
                              col: col,
                              props: props,
                            });
                          }
                        "
                      />
                    </span>
                    <span v-else>
                      {{ formatedValue(col) }}
                    </span>
                    <q-btn
                      v-if="col.name === 'showhide'"
                      flat
                      round
                      color="primary"
                      class="q-mr-sm"
                      :icon="
                        props.expand
                          ? 'keyboard_arrow_up'
                          : 'keyboard_arrow_down'
                      "
                      @click="props.expand = !props.expand"
                    />
                  </q-td>
                  <q-td style="width: 1px" nowrap>
                    <span class="buttons-row">
                      <span
                        v-for="(button, index) in buttonsRight"
                        :key="index"
                        :class="button.name"
                      >
                        <q-btn
                          flat
                          small
                          :class="button.name + '-btn protocol-close'"
                          color="primary"
                          :disable="!filterButton(button, props.row, false)"
                          v-if="filterButton(button, props.row, true)"
                          @click="actionButtonBillingOrder(button, props.row)"
                        >
                          <q-icon :name="iconAction(button)" size="22px" />
                          <q-tooltip v-if="button.tooltip">
                            {{ tooltip(button, props.row) }}
                          </q-tooltip>
                          <q-tooltip v-else>{{ button.label }}</q-tooltip>
                        </q-btn>
                      </span>
                    </span>
                  </q-td>
                </q-tr>
                <q-tr v-show="props.expand" :props="props">
                  <q-td colspan="100%">
                    <div class="row hidden-row">
                      <div
                        v-for="(col, key) in $refs.jtDataTable.hiddenColumns"
                        :key="key"
                        style="width: 33%;"
                      >
                        <label>{{ col.label }}:</label>
                        {{
                          formatedValue({
                            ...col,
                            value: props.row[col.model || col.field],
                          })
                        }}
                      </div>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </billing-order-jt-data-table>
          </q-card-section>
        </q-card>

        <billing-order-dialog-hold-order
          @on-ok-click="onOkClick"
          ref="modalHoldOrder"
        />
        <billing-order-dialog-delete-order
          @on-ok-click="onOkClickDeleteOrder"
          ref="modalDeleteOrder"
        />
      </div>
    </div>
    <billing-order-send-measurement-report
      v-else
      :forms="measurementReportForm"
      :format="measurementReportFormat"
      @on-close="onCloseReport"
    />
    <billing-order-ticket-search-modal
      v-if="ticketModal.show"
      :maximized="true"
      v-bind="ticketModal"
      @input="(show) => (ticketModal.show = show)"
    />
    <!-- TODO - All the code bellow, should go to another components, here they should just be called -->
    <modal
      v-if="modalData.show"
      :show="modalData.show"
      :maximized="false"
      v-bind="modalData"
      @input="(show) => (modalData.show = show)"
      @action-button="actionButtonFilter"
    >
      <template slot="form" slot-scope="{ form, actionClick }">
        <jt-dynamic-form
          ref="dynamicForm"
          :inputs="form.inputs"
          :relacionamentos="form.relacionamentos"
          :model="form.dadosForm"
          :interface="form.nmInterface"
          form-class="form dynamic"
          @action-click="actionClick"
          @search-found="onSearchFound"
        />
      </template>
    </modal>
    <q-dialog v-model="visible" persistent>
      <billing-order-report-selection
        :measurementReportParams="measurementReportParams"
        :measurementReportType="measurementReportType"
        :measurementReportFormat="measurementReportFormat"
        @generate-report="onGenerateReport"
      />
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import {
  JtCrud,
  JtDynamicForm,
  JtDataTableHiddenRow
} from 'jtech-webcomps'
import BillingOrderMethodsComunicate from './BillingOrderMethodsComunicate'
import { repository, messageBox } from 'jtech'
import BillingOrderDialogHoldOrder from './BillingOrderDialogHoldOrder.vue'
import BillingOrderDialogDeleteOrder from './BillingOrderDialogDeleteOrder.vue'
import BillingOrderBatchReportCrudLayout from './BillingOrderBatchReportCrudLayout.vue'
import BillingOrderTicketSearchModal from './BillingOrderTicketSearchModal.vue'
import BillingOrderSendMeasurementReport from '../report/BillingOrderSendMeasurementReport.vue'
import BillingOrderModel from './state/BillingFiltersState.js'
import BillingOrderJtDataTable from './base-components/BillingOrderJtDataTable.vue'
import BillingOrderActionButtonsState from './state/BillingOrderActionButtonsState.js'
import billingOrderButtonsAction from './constants/billingOrderButtonsAction'
import BillingOrderReportSelection from '../../../components/billingOrder/BillingOrderReportSelection.vue'

const { CrudLayout } = JtCrud

const { pageTable, modal } = JtCrud

@Component({
  name: 'BillingOrderActionPageSearch',
  mixins: [BillingOrderJtDataTable, pageTable],
  components: {
    CrudLayout,
    BillingOrderSendMeasurementReport,
    BillingOrderDialogHoldOrder,
    BillingOrderDialogDeleteOrder,
    BillingOrderBatchReportCrudLayout,
    BillingOrderTicketSearchModal,
    modal,
    JtDynamicForm,
    JtDataTableHiddenRow,
    BillingOrderJtDataTable,
    BillingOrderReportSelection
  }
})
class BillingOrderActionPageSearch extends Vue {
  state = BillingOrderModel.getInstance();
  actionsState = BillingOrderActionButtonsState.getInstance();

  datatableLocal = null;
  visible = false;
  row = null;
  modalData = { show: false };
  measurementReportForm = null;
  measurementReportFormat = 'pdf';
  measurementReportType = this.$gettext('ANALYTICAL');
  forms = [];
  extraParam = {};
  ticketModal = { show: false };
  measurementReportParams = null;

  onCloseReport () {
    this.measurementReportForm = null
  }

  onActionChange () {
    this.reloadDataTable()
  }

  selection (billingOrderSelecteds) {
    this.applyFilterBySendMeasureamentAction(billingOrderSelecteds)
    this.applyFilterByJdeStatusAction(billingOrderSelecteds)
  }

  applyFilterByJdeStatusAction (billingOrderSelecteds) {
    if (this.actionsState.action === billingOrderButtonsAction.CHANGE_JDE_STATUS) {
      this.$refs.jtDataTable.selected = billingOrderSelecteds
    }
  }

  applyFilterBySendMeasureamentAction (billingOrderSelecteds) {
    if (this.actionsState.action === billingOrderButtonsAction.SEND_MEASUREAMENT) {
      this.$refs.jtDataTable.selected = billingOrderSelecteds.filter(
        (billingOrder) => {
          return !billingOrder.measurementSent && billingOrder.automatic == true && billingOrder.contractBillingType != 20560002
        }
      )
    }
  }

  async onSearchFound (data) {
    if (data.client.idField) {
      const param = { client: data.client.idField }
      const { registros } = await repository.resolveDatatableModel(
        'collectionPoint.pesquisarSelecao',
        param
      )

      this.modalData.forms[0].relacionamentos.collectionPoint = registros.map(
        (x) => {
          return { label: x.name, value: x.id }
        }
      )
    }
  }

  async onOkClickDeleteOrder (data) {
    try {
      this.extraParam = this.state.filters
      await repository.resolveLogic('billingOrder.excluir', {
        id: this.row.id,
        description: data
      })
      this.$refs.modalDeleteOrder.hide()
      this.$refs.jtDataTable.refresh()
    } catch (error) {
      console.error(error)
    }
  }

  async mounted () {
    BillingOrderMethodsComunicate.$on('refresh-data-table', this.reloadDataTable)
    await this.loadJtDataTable()
  }

  async loadJtDataTable () {
    this.extraParam = this.state.filters
    this.datatableLocal = await repository.resolveDatatable(
      'billingOrder.pesquisarAction'
    )
  }

  reloadDataTable () {
    this.extraParam = this.state.filters
    this.$refs.jtDataTable.refresh()
  }

  get datatable () {
    return this.datatableLocal
  }

  get buttonsLeft () {
    return this.$refs.jtDataTable.buttonsRow.filter((b) => {
      return b.name != 'icExcluir' && b.name != 'btGerar'
    })
  }

  get buttonsRight () {
    return this.$refs.jtDataTable.buttonsRow.filter((b) => {
      return b.name == 'icExcluir' || b.name == 'btGerar'
    })
  }

  paintCell (_cell) {
    switch (_cell.col.name) {
      case 'billingOrderStatusName':
        return this.billingOrderStatus(_cell)
      case 'measurementSent':
        return this.measurementSentCell(_cell)
      case 'personName':
        return (
          _cell.props.row.personName +
          '<br><span style="font-size:xx-small">' +
          _cell.props.row.city +
          '</span>'
        )
      case 'id':
        return (
          _cell.props.row.id +
          '<br><span style="font-size:xx-small">' +
          (_cell.props.row.splitId
            ? `${this.$gettext('FATHER')}: ${_cell.props.row.splitId}`
            : '') +
          '</span>'
        )
      default:
        return false
    }
  }

  measurementSentCell (_cell) {
    if (_cell.props.row.measurementSent) {
      return '<span class="material-icons">done</span>'
    } else {
      return '<span></span>'
    }
  }

  billingOrderStatus (_cell) {
    switch (Number(_cell.props.row.billingOrderStatus)) {
      case 20300001:
        return `<div style="width:100%; height:22px;" class="visible" title="${_cell.props.row.alertCorrectionNeeded || ''}">
         <span class="material-icons" style="font-size: 20px; color: red;">report_problem</span>
        </div>`
      case 20300002:
        return '<span class="material-icons" style="font-size: 20px;">done</span>'
    }
  }

  async onToggleChange (_event) {
    if (_event.props.row.holdOrder) {
      this.$refs.modalHoldOrder.show(_event)
      this.row = _event.props.row
    } else {
      const billingOrderReturn = await repository.resolveLogic('billingOrder.alterarHoldOrder', {
        id: _event.props.row.id,
        holdOrder: _event.props.row.holdOrder,
        ..._event.props.row
      })
      _event.props.row.billingOrderStatus = billingOrderReturn.billingOrderHistory
      _event.props.row.alertCorrectionNeeded = billingOrderReturn.alertCorrectionNeeded
      this.paintCell(_event)
      BillingOrderMethodsComunicate.$emit('refresh-grid', this)
    }
  }

  async onOkClick (params) {
    const billingOrderReturn = await repository.resolveLogic('billingOrder.alterarHoldOrder', {
      id: this.row.id,
      holdOrder: this.row.holdOrder,
      observationIternal: params.reason,
      ...this.row
    })
    this.$refs.modalHoldOrder.hide()
    BillingOrderMethodsComunicate.$emit('refresh-grid', this)
    this.row = params.event.props.row
    params.event.props.row.billingOrderStatus = billingOrderReturn.billingOrderHistory
    params.event.props.row.alertCorrectionNeeded = billingOrderReturn.alertCorrectionNeeded
    this.paintCell(params.event)
  }

  actionButtonBillingOrder (button, params) {
    if (button.name == 'icExcluir') {
      this.row = params
      this.$refs.modalDeleteOrder.show()
    } else if (button.name == 'btPesquisar') {
      this.actionButtonModalFilter(button, params)
    } else if (button.name == 'report') {
      this.actionButtonReport(button, params)
    } else if (button.name == 'btGerar') {
      this.goToTicket(params)
    } else {
      this.actionButton(button, params)
    }
  }

  async onGenerateReport ({ measurementReportType, measurementReportFormat }) {
    this.measurementReportType = measurementReportType
    this.measurementReportFormat = measurementReportFormat
    await this.openDialogReport()
  }

  async openDialogReport () {
    const bodyRequest = { ...this.measurementReportParams, relFormatoRelatorio: this.relFormatoRelatorio }
    const repoForm = await this.fetchMeasureamentReport(bodyRequest)
    repoForm[0].dadosForm = { ...repoForm[0].dadosForm, ...bodyRequest }
    this.measurementReportForm = repoForm
    this.visible = false
  }

  async fetchMeasureamentReport (bodyRequest) {
    if (this.measurementReportParams && this.measurementReportParams.contractBillingType === 20560005) {
      if (this.measurementReportType === this.$gettext('SYNTHETIC')) {
        return await repository.resolve('industrialMovementMeasurementSyntheticReport.industrialMovementMeasurementSyntheticReport', bodyRequest)
      } else {
        return await repository.resolve('industrialMovementMeasurementReport.industrialMovementMeasurementReport', bodyRequest)
      }
    }
    return await repository.resolve('billingOrderSendMeasurementReport.billingOrderSendMeasurementReport',
      bodyRequest
    )
  }

  actionButtonReport (button, params) {
    this.visible = true
    this.measurementReportParams = { billingOrder: params.id, contractBillingType: params?.contractBillingType }
  }

  goToTicket (params) {
    this.ticketModal.show = true
    this.ticketModal.params = {
      billingOrder: params.id
    }
  }

  actionButtonFilter (button, params) {
    this.state.setFilters(params)
    this.modalData.show = false
    this.$refs.jtDataTable.extraParams = params
    this.$refs.jtDataTable.refresh()
  }

  async actionButtonModalFilter (button) {
    const data = await repository.resolve(button.action)
    this.modalData = {
      show: true,
      label: button.label,
      forms: data,
      detail: false,
      parent: this
    }
  }

  get relFormatoRelatorio () {
    return this.measurementReportFormat === 'pdf' ? 1 : 3
  }

  renderRowCheBox (props) {
    if (props.row?.hasOnlyComplementItemBilling === 'true') {
      return false
    }
    if (this.actionsState.action === billingOrderButtonsAction.SEND_MEASUREAMENT) {
      return !props.row.measurementSent && props.row.automatic && props.row?.contractBillingType != 20560002
    }
    return true
  }

  meusBotoes (botoes) {
    return botoes
  }
}
export default BillingOrderActionPageSearch
</script>
<style lang="stylus" scoped>

#scroll-table-billing-order-action {
  .q-table__middle {
    height: 60vh
  }

  .table_header thead tr:first-child th {
    font-size: 0.85em
  }

}
</style>
